import { Skeleton as MUISkeleton } from '@mui/material';

const Skeleton = MUISkeleton;

export default Skeleton;
